<div class="atlas-form mct-flex mct-row mct-flex-lt-md mct-col-lt-md mct-justify-start mct-items-center mct-gap-27"    >
  <div>
    <label>{{ 'coupons.search.status' | translate | ucfirst }}</label>
    <p-select name="status" appendTo="body" [(ngModel)]="searchParams.Approved" [options]="statusItems"></p-select>
  </div>

  <div class="coupon-search-flex mct-flex-1-1-0-lt-md"  >
    <label>{{ 'coupons.search.profile-name' | translate | ucfirst }}</label>
    <input
      name="profileName"
      [(ngModel)]="searchParams.ProfileName"
      [placeholder]="'coupons.search.profile-name-placeholder' | translate | ucfirst"
    />
  </div>

  <div>
    <label>{{ 'coupons.search.submitted-date' | translate | ucfirst }}</label>
    <div class="mct-flex mct-row mct-justify-start mct-items-center mct-gap-10"   >
      <wl-date-selector appendTo="body" [(ngModel)]="searchParams.SubmittedDateRangeStart"></wl-date-selector>
      <span>
        {{ 'common.through' | translate }}
      </span>
      <wl-date-selector
        appendTo="body"
        [(ngModel)]="searchParams.SubmittedDateRangeEnd"
        [minDate]="searchParams.SubmittedDateRangeStart"
      ></wl-date-selector>
    </div>
  </div>

  <div class="mct-flex mct-col">
    <div>&nbsp;</div>
    <div class="mct-flex mct-row mct-justify-center mct-items-start mct-gap-8">
      <p-checkbox [(ngModel)]="searchParams.IncludeMemberCouponsOnly" [binary]="true" inputId="includeMemberCouponsOnly"> </p-checkbox>
      <label for="includeMemberCouponsOnly" style="margin-bottom: 0; cursor: pointer;">
        {{ 'coupons.search.view-only-member-coupons' | translate | titlecase }}
      </label>
    </div>
  </div>
</div>
